// extracted by mini-css-extract-plugin
export default {"pageWrapper":"LeaderboardPage-module__pageWrapper--zfeG4","tabs":"LeaderboardPage-module__tabs--NFbGO"};